import type { MetaDescriptor } from 'react-router';

export const APP_NAME = 'Granular Energy';

// Page name first so it survives tab truncation when several pages are open.
export const pageTitle = (title: string) => `${title} | ${APP_NAME}`;

export const pageMeta = (title: string): MetaDescriptor[] => [{ title: pageTitle(title) }];
